'use client';
import { omitIf } from '../omitIf/omitIf.js';

/**
 * Удаляет ключи из объекта, значения которых равны undefined.
 *
 * @typeParam T - Тип объекта
 *
 * @param object - Исходный объект, из которого требуется удалить значения undefined
 *
 * @returns Новый объект, содержащий только те ключи и значения, которые не равны undefined
 *
 * @primaryExample
 * omitUndefined({ name: 'Alice', age: undefined, active: false, email: undefined })
 * // { name: 'Alice', active: false }
 *
 * @note
 * Функция использует {@link omitIf} для удаления значений undefined и возвращает новый объект, не изменяя исходный.
 */ const omitUndefined = (object)=>{
    return omitIf(object, (value)=>value === undefined);
};

export { omitUndefined };
//# sourceMappingURL=omitUndefined.js.map
